import { captureException } from '@sentry/react';
import { enqueueSnackbar } from '~/utils/notifications';
import { redactDicomUids } from '~/utils/phiRedaction';

/** Extract a user-friendly error message from an unknown error */
export const getErrorMessage = (error: unknown): string => {
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    return 'Unknown error';
};

/**
 * Logs an error with every DICOM UID redacted, reports it to Sentry (which
 * redacts on its own), and optionally tells the user.
 */
export const handleError = (
    error: unknown,
    errorMessage?: string,
    key?: string
) => {
    console.error(redactDicomUids(error));
    captureException(error);
    if (errorMessage) {
        enqueueSnackbar(errorMessage, {
            variant: 'error',
            key,
        });
    }
};
